import { Box } from '@chakra-ui/react';
import { sanitizeDom } from '@/lib/purify';
import { KText } from '@/ui-library/components/text';

export const SanitizedText = ({ html, ...props }) => {
  return (
    <KText dangerouslySetInnerHTML={{ __html: sanitizeDom(html) }} {...props} />
  );
};

export const SanitizedBox = ({ html, ...props }) => {
  return (
    <Box dangerouslySetInnerHTML={{ __html: sanitizeDom(html) }} {...props} />
  );
};
